import "./styles.css";
import facebookLogo from "../../../assets/facebook.png";
import twitterLogo from "../../../assets/twitter.png";
import instagramLogo from "../../../assets/instagram.png";
import youtubeLogo from "../../../assets/youtube.png";

const SOCIAL_LINKS = [
  {
    title: "Follow us on Facebook",
    href: "https://www.facebook.com/rwandahealth",
    img: facebookLogo,
  },
  {
    title: "Follow us on X (Twitter)",
    href: "https://x.com/RwandaHealth",
    img: twitterLogo,
  },
  {
    title: "Follow us on Instagram",
    href: "https://www.instagram.com/rwandahealth",
    img: instagramLogo,
  },
  {
    title: "Subscribe on YouTube",
    href: "https://www.youtube.com/channel/UCYtRdeEh1ODvBuZjSZWV2XQ",
    img: youtubeLogo,
  },
];

const LinkedInIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="22"
    height="22"
    fill="#0A66C2"
    aria-hidden="true"
  >
    <path d="M20.447 20.452H17.02v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.607V9h3.289v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a1.914 1.914 0 1 1 0-3.828 1.914 1.914 0 0 1 0 3.828zm1.646 13.019H3.691V9h3.292v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <div className="footer-container">
      <div className="container">
        <div className="col-md-10">
          <div className="footer-content">
            <div className="footer-left-container">
              {SOCIAL_LINKS.map(({ title, href, img }) => (
                <a
                  key={href}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={title}
                  className="social-icon-item"
                >
                  <img src={img} alt={title} />
                </a>
              ))}
              <a
                href="https://www.linkedin.com/company/ministry-of-health-republic-of-rwanda"
                target="_blank"
                rel="noopener noreferrer"
                title="Connect on LinkedIn"
                className="social-icon-item"
              >
                <LinkedInIcon />
              </a>
            </div>
            <div className="middle-container">
              <span></span>
            </div>
            <div className="right-container">
              <span>
                &copy; {year}{" "}
                <a
                  href="https://www.moh.gov.rw/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary text-bold"
                >
                  Ministry of Health
                </a>. All rights reserved.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
